import type { MutableRefObject } from "react";
import { useEffect, useState, useRef } from "react";
import { useTheme } from "styled-components";
import { useWindowDimensions } from "../hooks";
import type { PersonalisationItemType } from "../types/CommonTypes";

type useItemSliderReturnType = {
    itemWidth: number;
    viewportWidth: number;
    extraPadding: number;
    listWrapper: MutableRefObject<HTMLDivElement | null>;
    isRTL: boolean;
};

const useItemSlider = (items: PersonalisationItemType[], itemWidth: number): useItemSliderReturnType => {
    const listWrapper = useRef<HTMLDivElement>(null);
    const [extraPadding, setExtraPadding] = useState(0);

    // Set the viewport width of the slider to propagate to useSlider.
    const windowWidth = useWindowDimensions().width;
    const [viewportWidth, setViewportWidth] = useState<number>(0);
    useEffect(() => {
        if (listWrapper.current) {
            const newViewportWidth = listWrapper.current.getBoundingClientRect().width;
            if (newViewportWidth !== viewportWidth) setViewportWidth(newViewportWidth);
        }
    }, [windowWidth]);

    // Make sure to always show a partial swatch on mobile so the user knows he can scroll
    const { breakpoints, isRTL } = useTheme();
    useEffect(() => {
        if (windowWidth <= parseInt(breakpoints.lg)) {
            const amountOfItems = windowWidth <= parseInt(breakpoints.sm) ? 4.5 : 5.5;
            if (items.length >= amountOfItems) {
                const padding = (viewportWidth - itemWidth * amountOfItems) / amountOfItems;
                setExtraPadding(Math.max(0, Math.round(padding / 2)));
            }
        } else if (extraPadding) {
            setExtraPadding(0);
        }
    }, [windowWidth, viewportWidth, items]);

    return {
        itemWidth,
        viewportWidth,
        extraPadding,
        listWrapper,
        isRTL,
    };
};

export default useItemSlider;
